export class ApiClient {
    constructor() {
        // Keep bearer tokens in memory only. A live viewing token must not survive
        // tab closure or be exposed to other same-origin pages via web storage.
        this._sessionToken = null;
    }
    get token() {
        return this._sessionToken;
    }
    set token(value) {
        this._sessionToken = value;
    }
    headers() {
        const h = { 'Content-Type': 'application/json' };
        const t = this.token;
        if (t) {
            h['Authorization'] = `Bearer ${t}`;
        }
        return h;
    }
    setToken(token) {
        this.token = token;
    }
    clearToken() {
        this.token = null;
    }
    hasToken() {
        return this.token !== null;
    }
    async request(path, options = {}) {
        const url = path.startsWith('http') ? path : path;
        const res = await fetch(url, {
            ...options,
            headers: { ...this.headers(), ...(options.headers ?? {}) },
        });
        if (!res.ok) {
            if (res.status === 401) {
                this.clearToken();
            }
            const body = await res.json().catch(() => ({ error: 'request_failed' }));
            throw body;
        }
        return res.json();
    }
    async post(path, body) {
        return this.request(path, {
            method: 'POST',
            body: body ? JSON.stringify(body) : undefined,
        });
    }
    async get(path) {
        return this.request(path, { method: 'GET' });
    }
    async patch(path, body) {
        return this.request(path, {
            method: 'PATCH',
            body: body ? JSON.stringify(body) : undefined,
        });
    }
    async delete(path) {
        return this.request(path, { method: 'DELETE' });
    }
}
export const api = new ApiClient();
